<template>
  <div class="app-container">
    <Container
      :title="t('Acceptance.approveDetail')"
      :hasLine="true"
      style="min-height: 600px"
    >
      <template #main>
        <div class="accepted-bills-table">
          <SimpleTable
            ref="tableRef"
            :listLoading="listLoading"
            :tableData="tableData"
            :columnStruct="columnStruct"
            :hadSelect="false"
            :had-operate="false"
          />
        </div>
        <div class="relative-div">
          <el-form
            label-width="680px"
            ref="cFormRef"
            label-position="left"
            style="margin-left:2%; font-size: 14px;"
          >
            <el-row :gutter="4">
              <el-form-item
                :label="t('Acceptance.AcceptanceTotalAmount')"
                label-width="160px"
                style="text-align: left;"
              >
                <span>{{ formatThousands(totalDraftAmt) }}</span>
              </el-form-item>
            </el-row>
            <el-row :gutter="4">
              <el-form-item
                :label="t('Acceptance.approvalType')"
                label-width="160px"
                style="text-align: left;"
              >
                <span>{{ receiveType }}</span>
              </el-form-item>
            </el-row>
            <el-row :gutter="4">
              <el-form-item
                :label="t('Acceptance.finalApprover')"
                label-width="160px"
                style="text-align: left;"
              >
                <span>{{ finalApprover }}</span>
              </el-form-item>
            </el-row>
            <el-row :gutter="4">
              <el-form-item
                :label="t('Acceptance.status')"
                label-width="160px"
                style="text-align: left;"
              >
                <span>{{ finalStatus }}</span>
              </el-form-item>
            </el-row>
            <el-row :gutter="4">
              <el-form-item
                :label="t('Acceptance.rejectionReason')"
                label-width="160px"
                style="text-align: left;"
              >
                <span>{{ rejectionReason }}</span>
              </el-form-item>
            </el-row>
          </el-form>
        </div>
      </template>
    </Container>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref, toRefs } from 'vue'
import { formatDate, formatThousands } from '@/utils'
import { formatDraftType } from '@/utils/acceptanceBillFormatUtil'
import { getApprovalHistoryDetails } from '@/apis/accepted-bill/acceptanceReceipt'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import Container from '@/components/form/container/Container.vue'
import { ElMessage } from 'element-plus'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import { SubmittedAcceptanceBillListItemModel } from '@/model/accepted-bill/approvalFormModel'

export default defineComponent({
  name: 'AcceptanceApprovalHistoryDetail',
  components: {
    SimpleTable,
    Container
  },
  methods: { formatThousands },
  setup() {
    const { t } = useI18n()
    const tableRef = ref()
    const id = useRoute().params.id.toString()
    const detailTableStruct = [
      { prop: 'id', label: t('Acceptance.id') },
      { prop: 'companyCode', label: t('company.companyCode') },
      { prop: 'requestObject', label: t('Acceptance.requestObject'), width: 270 },
      { prop: 'draftNo', label: t('Acceptance.draftNo'), width: 270 },
      {
        prop: 'requestDate',
        label: t('Acceptance.requestDate'),
        formatter: (row: SubmittedAcceptanceBillListItemModel) => formatDate(row.requestDate, 'yyyy-MM-dd')
      },
      { prop: 'draftType', label: t('Acceptance.draftType'), formatter: (row: SubmittedAcceptanceBillListItemModel) => formatDraftType(row.draftType), width: 120 },
      { prop: 'bankName', label: t('Acceptance.bankName'), width: 270 },
      { prop: 'draftAmt', label: t('Acceptance.draftAmt'), width: 120, formatter: (row: any) => formatThousands(row.draftAmt), align: 'right' }
    ]
    const dataMap = reactive({
      totalDraftAmt: '',
      receiveType: '',
      finalApprover: '',
      finalStatus: '',
      rejectionReason: '',
      tableData: Array<SubmittedAcceptanceBillListItemModel>(),
      columnStruct: detailTableStruct,
      listLoading: true,
      async getData() {
        dataMap.listLoading = true

        let approvalId
        try {
          approvalId = Number(id)
        } catch (error) {
          ElMessage({
            message: 'id 格式错误;' + id,
            type: 'error',
            duration: 2000
          })
          return
        }
        const data = await getApprovalHistoryDetails(approvalId)
        if (data && data.data) {
          dataMap.totalDraftAmt = data.data.totalDraftAmt
          dataMap.finalApprover = data.data.approverName
          dataMap.rejectionReason = data.data.comments
          dataMap.finalStatus = data.data.approvalResult ? t('approvalForm.approved') : t('approvalForm.rejected')
          switch (data.data.receiveType) {
            case 1:
              dataMap.receiveType = t('Acceptance.signForReceipt')
              break
            case 2:
              dataMap.receiveType = t('Acceptance.applicationRejected')
              break
            default:
              dataMap.receiveType = ''
              break
          }
          dataMap.tableData = data.data.acceptanceBillList
        } else {
          dataMap.totalDraftAmt = ''
          dataMap.finalApprover = ''
          dataMap.rejectionReason = ''
          dataMap.finalStatus = ''
          dataMap.receiveType = ''
          dataMap.tableData = []
          if (data?.code !== 200 && data?.msg) {
            ElMessage({
              message: data.msg,
              type: 'error',
              duration: 2000
            })
          }
        }

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      }
    })
    onMounted(() => {
      dataMap.getData()
    })
    return {
      t,
      tableRef,
      ...toRefs(dataMap)
    }
  }
})
</script>

<style
  scoped
  lang="scss"
>
.accepted-bills-table{
  width: 90%;
}
.relative-div {
  position: relative;
  top: 50px; /* 向下移动20px */
}
@media (max-width: 768px) {
  .accepted-bills-table{
    width: 100%;
  }
}
</style>
